import { DocFile } from "@app/shared";
import {AchFundingSource} from "@app/shared/ach/org-payment-transaction";

export class PartnerAchDetail {
  id: number;
  version: number;
  partnerId: number;
  nickName: string;
  accountType: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  routingNumber: string;
  current: boolean;
  active: boolean;
  achDefaultPaymentType?: string;


  // optional fields to support org-payment-info component
  signatureImage?: DocFile;
  achFundingSourceDetails?: AchFundingSource;
}

// export enum AchAccountType {
//   CHECKING = 'CHECKING',
//   SAVINGS = 'SAVINGS',
//   LOAN = "LOAN",
//   GENERAL_LEDGER = "GENERAL_LEDGER"
// }

export class MicroDepositAmount {
  value: string;
  currency: string;
  constructor () {
    this.currency = 'USD';
  }
}

export class AchMicroDepositVerification {

  amount1: MicroDepositAmount;
  amount2: MicroDepositAmount;

  constructor () {
    this.amount1 = new MicroDepositAmount();
    this.amount2 = new MicroDepositAmount();
  }

}

export enum VendorPaymentMessages {
  NewAchUseForPrimaryPay = "Payments will be made to the new account. Any older accounts marked as primary pay will be reset",
  UpdateAchForPrimaryPay = "Payments will be made to the this account. Any older accounts marked as primary pay will be reset",
  DeletePrimaryPayMessage = "Please add (or) update a primary pay account before deleting current Primary Pay account.",
  UpdatePrimaryPaytoNonPrimaryPay = "Please add (or) update a primary pay account before disabling the current primary pay account"
}
